import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountDataAllFeedStatus implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountDataAllFeedStatusContainer";
    }
    render(){
        // console.log("data feed status");
        let self=this;
        setTimeout(function(){
            window.location.reload();
        }, 10000);
    }
}